import React, { Component } from 'react';
import {
  channelStore,
  chatStore,
  quickMsgStore,
  rSocket,
  ticketStore,
} from '../store/FrontChatStore';
import axios from 'axios';
import Cookies from 'js-cookie';
import {
  COOKIE_KEY_USER_ID,
  COOKIE_KEY_USER_KEY,
  COOKIE_KEY_CHANNEL_ID,
  COOKIE_KEY_TEL_NO,
  COOKIE_KEY_SCENARIO_YN,
  COOKIE_KEY_SCENARIO_ID,
  COOKIE_KEY_CHAT_YN,
} from '../const/AppConst';
import { v4 as uuid } from 'uuid';
import { ADJECTIVES, ANIMALS } from '@qbot-chat/qbot-uikit';
import { navigateReplace } from '../helper/HistoryHelper';
import { observer } from 'mobx-react';

@observer
class InitView2 extends Component {
  userKey = Cookies.get(COOKIE_KEY_USER_KEY);

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      error: null,
      params: {
        inflowType: 'ARS',
        userKey: this.userKey,
        userId: Cookies.get(COOKIE_KEY_USER_ID),
        chatBotType: '',
        sid: '',
        chatYn: 'N',
      },
    };
  }

  componentDidMount() {
    // 기존 세션 정리
    this.clearExistingSession();

    // userKey 초기화 (InitView와 동일한 로직)
    if (!this.userKey || this.userKey == 'undefined') {
      this.userKey = uuid();
      Cookies.set(COOKIE_KEY_USER_KEY, this.userKey);
      this.setState({ userKey: this.userKey });
    }

    // URL 쿼리스트링에서 파라미터 추출 (해시 라우팅 대응)
    let searchParams = window.location.search;

    // 해시 라우팅인 경우 해시 뒤의 쿼리 파라미터를 추출
    if (!searchParams && window.location.hash.includes('?')) {
      const hashParts = window.location.hash.split('?');
      if (hashParts.length > 1) {
        searchParams = '?' + hashParts[1];
      }
    }

    const urlParams = new URLSearchParams(searchParams);

    // 디버깅을 위한 로그
    console.log('Current URL:', window.location.href);
    console.log('Hash:', window.location.hash);
    console.log('Search params:', searchParams);
    console.log('URLSearchParams entries:');
    for (let [key, value] of urlParams.entries()) {
      console.log(`${key}: ${value}`);
    }

    // 필수 파라미터 확인
    const requiredParams = ['chatBotType', 'sid'];
    const missingParams = requiredParams.filter(
      (param) => !urlParams.get(param),
    );

    console.log('Required params:', requiredParams);
    console.log('Missing params:', missingParams);
    console.log('chatBotType value:', urlParams.get('chatBotType'));
    console.log('sid value:', urlParams.get('sid'));
    console.log('name value:', urlParams.get('name'));

    if (missingParams.length > 0) {
      this.setState({
        isLoading: false,
        error: `필수 파라미터가 누락되었습니다: ${missingParams.join(', ')}`,
      });
      return;
    }

    // 파라미터 설정 (InitView와 동일한 방식)
    const params = {
      inflowType: urlParams.get('inflowType') || 'ARS',
      userKey: this.userKey,
      userId: Cookies.get(COOKIE_KEY_USER_ID),
      chatBotType: urlParams.get('chatBotType') || '',
      sid: urlParams.get('sid') || '',
      chatYn: urlParams.get('chatYn') || 'N',
      name: urlParams.get('name') || '',
    };

    this.setState({ params }, () => {
      // 쿠키 설정
      this.setupCookies();
      // 채팅 시작
      this.startChat();
    });
  }

  clearExistingSession = () => {
    // 기존 채팅 관련 쿠키 정리
    Cookies.remove(COOKIE_KEY_CHANNEL_ID);
    Cookies.remove(COOKIE_KEY_USER_ID);
    Cookies.remove(COOKIE_KEY_TEL_NO);
    Cookies.remove(COOKIE_KEY_SCENARIO_YN);
    Cookies.remove(COOKIE_KEY_SCENARIO_ID);
    Cookies.remove(COOKIE_KEY_CHAT_YN);

    // 기존 RSocket 연결 종료
    if (rSocket) {
      rSocket.close();
    }

    // 스토어 초기화 (clear 메서드가 있는 경우에만)
    try {
      if (chatStore && typeof chatStore.clear === 'function') {
        chatStore.clear();
      }
      if (channelStore && typeof channelStore.clear === 'function') {
        channelStore.clear();
      }
      if (ticketStore && typeof ticketStore.clear === 'function') {
        ticketStore.clear();
      }
      if (quickMsgStore && typeof quickMsgStore.clear === 'function') {
        quickMsgStore.clear();
      }
    } catch (error) {
      console.log('스토어 초기화 중 오류:', error);
    }

    console.log('기존 세션이 정리되었습니다.');
  };

  setupCookies = () => {
    const { params } = this.state;

    // 채팅 타입 설정
    Cookies.set(COOKIE_KEY_CHAT_YN, params.chatYn);

    // 전화번호 설정
    Cookies.set(COOKIE_KEY_TEL_NO, params.chatBotType);

    // 시나리오 설정
    Cookies.set(COOKIE_KEY_SCENARIO_YN, 'Y');
    Cookies.set(COOKIE_KEY_SCENARIO_ID, params.sid);
  };

  startChat = async () => {
    try {
      const { params } = this.state;

      if (!params.chatBotType) {
        throw new Error('상담할 회사의 전화번호가 존재하지 않습니다.');
      }

      await rSocket.close();
      let user_key = Cookies.get(COOKIE_KEY_USER_KEY);

      // 사용자 생성/검색 (URL에서 받은 name 사용)
      const { data: customer } = await rSocket.requestChatApi(`/user/search`, {
        key: user_key,
        name:
          params.name ||
          `${ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]} ${
            ANIMALS[Math.floor(Math.random() * ANIMALS.length)]
          }`,
      });

      console.log('Customer created:', customer);

      // 사용자 ID 쿠키 설정 (InitView와 동일한 방식)
      Cookies.set(COOKIE_KEY_USER_ID, customer.id);
      if (customer.id) {
        this.setState({ userId: customer.id });
      }

      // RSocket 연결 및 실행
      await rSocket.run(
        {
          sender: customer,
          ticket: ticketStore,
          channel: channelStore,
          chat: chatStore,
        },
        (rsocket) => {
          quickMsgStore.setRSocketStore(rSocket);
          chatStore.setQuickMsgStore(quickMsgStore);
        },
      );

      // 채널 로그 기록 (정상 로그와 동일한 request body 생성)
      axios.defaults.baseURL = '/mp/api/v1';
      let requestParams = {
        inflowType: this.state.params.inflowType,
        userKey: this.state.params.userKey,
        userId: customer.id, // customer.id를 직접 사용
        chatBotType: this.state.params.chatBotType,
        sid: this.state.params.sid,
        chatYn: this.state.params.chatYn,
      };
      console.log('Append request params:', requestParams);

      const response = await axios.post('/channel-log/append', requestParams);
      const channelId = response.data.channelId;

      // 채널 ID 쿠키 설정
      Cookies.set(COOKIE_KEY_CHANNEL_ID, channelId);

      // 로딩 페이지로 이동
      console.log(
        '채팅이 성공적으로 시작되었습니다. 로딩 페이지로 이동합니다.',
      );
      console.log('Channel ID:', channelId);
      console.log('User ID:', customer.id);
      console.log('User Key:', user_key);

      // 로딩 페이지로 이동
      navigateReplace('/loading/false');
    } catch (error) {
      console.error('Chat start error:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        params: this.state.params,
      });
      this.setState({
        isLoading: false,
        error: error.message || '채팅 시작 중 오류가 발생했습니다.',
      });
    }
  };

  render() {
    const { isLoading, error } = this.state;

    if (isLoading) {
      return (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ height: '100vh' }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <div className="mt-3">채팅을 시작하고 있습니다...</div>
        </div>
      );
    }

    if (error) {
      return (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ height: '100vh' }}
        >
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">오류 발생</h4>
            <p>{error}</p>
            <hr />
            <p className="mb-0">
              URL 형식:
              /init2?chatBotType=전화번호&sid=시나리오ID&chatYn=Y&inflowType=ARS
            </p>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default InitView2;
